import { TResDataListApi } from '@src/configs/interface.config'
import { checkAuth } from '@src/libs/localStorage'
import { TQueryTransaction, TTransaction } from '@src/modules/transaction'
import { useQuery } from 'react-query'
import { getLisTransaction } from '@queries/apis'
import { LIST_TRANSACTION } from '@queries/keys'

export const useQueryListTransaction = (params: TQueryTransaction, token?: string) => {
  const accessToken = token || checkAuth()
  return useQuery<TResDataListApi<TTransaction[]>>(
    [LIST_TRANSACTION, params.userId, JSON.stringify(params)],
    () => getLisTransaction(params, accessToken),
    {
      enabled: !!accessToken,
    },
  )
}
